export const BLUE = 'blue'
export const RED = 'red'
export const ORANGE = 'orange'
export const GREEN = 'green'
export const GREY = 'grey'

export default (grade) => {
  if (grade == null) {
    return BLUE;
  } else if (grade < 0.32) {
    return RED;
  } else if (grade < 0.83) {
    return ORANGE;
  } else if (grade <= 1.0) {
    return GREEN;
  }
  return GREY;
};
